const ua = navigator.userAgent.toLowerCase();
let UA = {};

UA.androidClient = !!ua.match(/wlhyOS/i); // 是否安卓客

export const isDriverClient = !!ua.match(/wlhyOS/i);

export default UA;
